import type { ReactNode } from 'react'
import s from './Kbd.module.css'

/** A key to press, e.g. ⌘K. Hidden on touch-only screens, where there is no keyboard to press it on. */
export function Kbd(props: { children: ReactNode }) {
  return <kbd className={s.kbd}>{props.children}</kbd>
}
